import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';

// Objeto con todos los links del footer
const footerLinks = {
  quickLinks: {
    title: "Enlaces Rápidos",
    links: [
      { name: "Productos", url: "/products" },
      { name: "Soporte", url: "/contact" },
      { name: "SiteMap", url: "/sitemap" }
    ]
  },
  legal: {
    title: "Legal",
    links: [
      { name: "Términos y Condiciones", url: "/terms" },
      { name: "Política de Privacidad", url: "/privacy" },
      { name: "Términos de Devolución", url: "/return-policy" }
    ]
  }
};

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setEmailError('Por favor, ingresa un correo electrónico.');
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setEmailError('Por favor, ingresa un correo electrónico válido.');
    } else {
      setEmailError('');
      console.log('Formulario enviado con éxito', email);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-primary to-dark">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Columna About */}
          <div className="space-y-4">
            <h3 className="text-2xl font-poppins font-bold text-white mb-4">SAHEZ MEDIC</h3>
            <p className="font-montserrat text-white">
              Líderes en tecnología médica desde 2010. Equipamiento certificado y soluciones integrales para la salud.
            </p>
            <div className="flex space-x-4 mt-6">
              {[Facebook, Twitter, Instagram, Linkedin].map((Icon, index) => (
                <Icon 
                  key={index}
                  className="h-6 w-6 cursor-pointer text-blue-950 transition-colors hover:text-blue-950"
                />
              ))}
            </div>
          </div>
          
          {/* Quick Links Mapeados */}
          <div className="space-y-4">
            <h3 className="text-2xl font-poppins font-bold text-white mb-4">
              {footerLinks.quickLinks.title}
            </h3>
            <ul className="space-y-3 font-montserrat">
              {footerLinks.quickLinks.links.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.url} 
                    className="text-white hover:text-blue-950 transition-colors flex items-center gap-1"
                  >
                    <span className="text-blue-950">▹</span> {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-2xl font-poppins font-bold text-white mb-4">Contacto</h3>
            <ul className="space-y-4 font-montserrat">
              <li className="flex items-center gap-2 text-white">
                <Mail className="h-5 w-5 text-blue-950" />
                contacto@medequip.com
              </li>
              <li className="flex items-center gap-2 text-white">
                <Phone className="h-5 w-5 text-blue-950" />
                +34 910 123 456
              </li>
              <li className="flex items-center gap-2 text-white">
                <MapPin className="h-5 w-5 text-blue-950" />
                C/ Tecnología Médica 15, Madrid
              </li>
            </ul>
          </div>
          
          {/* Newsletter */}
          <div className="space-y-4">
            <h3 className="text-2xl font-poppins font-bold text-white mb-4">Boletín</h3>
            <p className="font-montserrat text-white">
              Suscríbete para actualizaciones de equipos y novedades en tecnología médica.
            </p>
            <form className="space-y-3" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Tu email"
                className="w-full px-4 py-3 rounded-lg bg-main-bg/20 border border-white/30 focus:outline-none focus:border-white placeholder:text-white/70 text-white"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {emailError && <p className="text-white text-sm">{emailError}</p>}
              <button type="button" className="w-full px-4 py-3 rounded-lg bg-dark text-main-bg font-poppins font-semibold hover:bg-accent transition-colors">
                Suscribirse
              </button>
            </form>
          </div>
        </div>
        {/* Bottom Section Mapeada */}
<div className="border-t border-white/20 mt-12 pt-8 text-center space-y-6">
  {/* Links Legales */}
  <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 font-montserrat text-white">
    {footerLinks.legal.links.map((link, index) => (
      <div key={link.name} className="flex items-center gap-2">
        <Link 
          to={link.url} 
          className="text-white hover:text-yellow-400 transition-colors font-semibold"
        >
          {link.name}
        </Link>
        {index !== footerLinks.legal.links.length - 1 && (
          <span className="text-white">|</span>
        )}
      </div>
    ))}
  </div>

  {/* Copyright */}
  <p className="text-white font-light">
    © {new Date().getFullYear()} SAHEZ MEDIC, EIRL. Todos los derechos reservados.
  </p>

  {/* Developer Info */}
  <p className="text-white font-light">
    Desarrollado por <Link to="https://www.edwincaba.com" className="text-yellow-400 hover:text-yellow-500 font-semibold">Edwin Rafael Caba</Link>
  </p>
</div>

      </div>
    </footer>
  );
};